// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__hoFeA","title":"Option_title__k2RBt","details":"Option_details__1AYUt","selected":"Option_selected__98g_Y"};